export const SET_PRODUCTS = "SET_PRODUCTS";
export const RESET_PRODUCTS = "RESET_PRODUCTS";
export const SET_SPECIFIC_PRODUCT = "SET_SPECIFIC_PRODUCT";
export const RESET_SPECIFIC_PRODUCT = "RESET_SPECIFIC_PRODUCT";
export const SET_VARIENT_OPTIONS = "SET_VARIENT_OPTIONS";
export const RESET_VARIENT_OPTIONS = "RESET_VARIENT_OPTIONS";
export const SET_OPTION_VALUES = "SET_OPTION_VALUES";
export const RESET_OPTION_VALUES = "RESET_OPTION_VALUES";
export const SET_SPECIFIC_VARIENTS = "SET_SPECIFIC_VARIENTS";
export const RESET_SPECIFIC_VARIENTS = "RESET_SPECIFIC_VARIENTS";
export const SET_ALL_VARIENTS = "SET_ALL_VARIENTS";
export const RESET_ALL_VARIENTS = "RESET_ALL_VARIENTS";
export const SET_ARTICLE_NUM = "SET_ARTICLE_NUM";
export const RESET_ARTICLE_NUM = "RESET_ARTICLE_NUM";
export const SET_CUSTOMER_ORDER_REVIEWS = "SET_CUSTOMER_ORDER_REVIEWS";
export const RESET_CUSTOMER_ORDER_REVIEWS = "RESET_CUSTOMER_ORDER_REVIEWS";
export const SET_CUSTOMER_ORDER_PENDING_REVIEWS = "SET_CUSTOMER_ORDER_PENDING_REVIEWS";
export const RESET_CUSTOMER_ORDER_PENDING_REVIEWS = "RESET_CUSTOMER_ORDER_PENDING_REVIEWS";
export const SET_CUSTOMER_QUESTIONS = "SET_CUSTOMER_QUESTIONS";
export const RESET_CUSTOMER_QUESTIONS = "RESET_CUSTOMER_QUESTIONS";
export const SET_MEDIA_CENTER_IMAGES = "SET_MEDIA_CENTER_IMAGES";
export const RESET_MEDIA_CENTER_IMAGES = "RESET_MEDIA_CENTER_IMAGES";
export const SET_MEDIA_CENTER_VIDEOS = "SET_MEDIA_CENTER_VIDEOS";
export const RESET_MEDIA_CENTER_VIDEOS = "RESET_MEDIA_CENTER_VIDEOS";
export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";
export const RESET_PRODUCT_LIST = "RESET_PRODUCT_LIST";

